import { RefObject } from "react";

import { Typography } from "@mui/material";
import moment from "moment";
import { Link, useParams } from "react-router-dom";

import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { TProgressSummary } from "../../hooks/useMyCourseInstructor";
import { TRequestMoneyDialogRef } from "./RequestMoneyDialog";

export type TUpcomingSummaryItemProps = {
	upcomingSummary: TProgressSummary;
	requestMoneyDialogRef: RefObject<TRequestMoneyDialogRef | null>;
};

export function UpcomingSummaryItem({
	upcomingSummary,
	requestMoneyDialogRef,
}: TUpcomingSummaryItemProps) {
	const { slug } = useParams();
	const student = upcomingSummary.student;
	const studentName = `${student.firstName} ${student.lastName}`.trim();

	const onClickOpenRequestMoney = () => {
		requestMoneyDialogRef.current?.open(
			studentName,
			upcomingSummary.studentId,
			upcomingSummary.id,
		);
	};

	return (
		<div className="learning-summary-item-container item-separator-big">
			<img
				src={
					student.profile?.thumbnail || student.profile?.url || noAvatarImage
				}
				className="avatar"
			/>
			<div style={{ flex: 1 }}>
				<Typography className="big-text bold">{studentName}</Typography>
				<div
					className="item-separator-small"
					style={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
					{upcomingSummary.nextAppointment && (
						<div className="summary-info-container">
							<Typography className="normal-text">
								<span className="bold">Next class:</span>
								{` ${upcomingSummary.nextAppointment.lesson.title}`}
							</Typography>
							<Typography className="normal-text">
								<span className="bold">Appointment Date:</span>
								{` ${moment(upcomingSummary.nextAppointment.startTime).format("dddd, D MMM YYYY, HH:mm")}`}
							</Typography>
						</div>
					)}
					<div className="summary-info-container">
						<Typography
							onClick={onClickOpenRequestMoney}
							className="normal-text bold gray-text underline-link">
							Request money
						</Typography>
						<div style={{ flex: 1 }} />
						<Link
							to={`/teaching/${slug}/${upcomingSummary.studentId}`}
							className="blue-text underline-link">
							<Typography className="normal-text bold">
								Student Binder
							</Typography>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
